export const getApiUrl = () => {
  if (process.env.NODE_ENV === "production") {
    return 'https://randomizer-api.tstark2.us';
  }
  return 'http://localhost:8080';
};
